import { types } from 'mobx-state-tree';


const PROPERTY_TYPES = {
    DETACHED: 'detached',
    SEMI_DETACHED: 'semidetached',
    CONDOMINIUM: 'condominium',
    ROW_HOUSING: 'row-housing',
};

const PropertyTypeEnum = types.enumeration('PropertyType', Object.values(PROPERTY_TYPES));

export {
    PropertyTypeEnum,
};
export default PROPERTY_TYPES;
